import React, { Component, PropTypes } from 'react';
import _ from 'underscore';
import cx from 'classnames';
import controllable from 'react-controllables';

class WizardNav extends Component {
  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.node).isRequired,
    activeOption: PropTypes.number.isRequired,
    onChangeActiveOption: PropTypes.func.isRequired,
    maxOption: PropTypes.number,
    justified: PropTypes.bool
  };

  static defaultProps = {
    maxOption: null,
    justified: true
  };

  render() {
    const { options, activeOption, onChangeActiveOption, justified, maxOption } = this.props;
    const numOptions = options.length;

    return (
      <ul className={cx('nav nav-pills nav-wizard', { 'nav-justified': justified })}>
        {
          _.map(options, (option, ix) => {
            const unavailable = maxOption && maxOption < ix;
            const active = activeOption === ix;

            return (
              <li key={ix} className={cx({ active, unavailable, available: !active && !unavailable })}>

                { ix > 0 ? <div key="wedge" className="nav-wedge"/> : null }

                <a
                  key="opt" onClick={(e) => {
                    e.preventDefault();
                    if (!active && !unavailable) {
                      onChangeActiveOption(ix);
                    }
                  }}
                >
                  { option }
                </a>

                { ix < numOptions - 1 ? <div key="arrow" className="nav-arrow"/> : null }

              </li>
            );
          })
        }
      </ul>
    );
  }
}

export default controllable(WizardNav, [ 'activeOption' ]);


// WEBPACK FOOTER //
// ./src/js/components/WizardNav.jsx